import { TextField } from '../../Components/Formik/BaseTextField';

export const FilterFields = ({ showAdditionalFields, setFilters, filterOptions, filters }) => (
  <div className="filter-container">
    <div className="filter-search">
      <TextField
        placeholder="Search by name..."
        onChange={(e) => setFilters((f) => ({ ...f, search: e.target.value }))}
        className="pl-10"
        value={filters.search}
      />
    </div>

    {(!showAdditionalFields ? filterOptions?.branches?.length > 1 : filterOptions?.regions) ? (
      <select
        className="filter-select"
        onChange={(e) => setFilters((f) => ({ ...f, [showAdditionalFields ? 'regions' : 'branch']: e.target.value ? [e.target.value] : [] }))}
      >
        {[
          { id: '', name: `All ${showAdditionalFields ? 'Regions' : 'Branches'}` },
          ...filterOptions?.[showAdditionalFields ? 'regions' : 'branches'],
        ].map((option) => (
          <option className="filter-select-option" key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    ) : null}
  </div>
);
